export default __webpack_public_path__ + "static/media/virusyellow-250-4-min.25b8723f.png";